/**
 * NonMemberNotice -- Shows non-member status messaging in the registration flow.
 * Displays surcharge amount and buddy-group eligibility info.
 */
import { AlertCircle, DollarSign } from 'lucide-react';
import { formatCurrency } from '@/utils/formatters';

interface NonMemberNoticeProps {
  surcharge: number;
  allowBuddyGroup: boolean;
}

export function NonMemberNotice({ surcharge, allowBuddyGroup }: NonMemberNoticeProps) {
  return (
    <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-4 space-y-2">
      <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400">
        <AlertCircle className="h-4 w-4" />
        <span className="text-sm font-medium">Non-Member Entry</span>
      </div>
      {surcharge > 0 && (
        <div className="flex items-center gap-2 text-sm text-amber-700 dark:text-amber-300">
          <DollarSign className="h-3 w-3" />
          <span>A non-member surcharge of {formatCurrency(surcharge)} will be added to your entry fee.</span>
        </div>
      )}
      {!allowBuddyGroup && (
        <p className="text-sm text-amber-700 dark:text-amber-300">
          Buddy group participation is not available for non-members at this organization.
        </p>
      )}
    </div>
  );
}
